import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from 'src/app/components/_alert/alert.service';
import { IFlujoLightTXPermissions, IGeneralReport } from 'src/app/interface/IFlujoLightTx';
import { FlujoCreditoLightService } from 'src/app/shared/services/flujo-credito-light.service';
import { goToTop } from '../utils/utils';
import { SessionService } from 'src/app/shared/services/session.service';
import { ESystemAccess } from 'src/app/enum/EAccess';

@Component({
    selector: 'app-flujo-credito-light-client-card',
    templateUrl: './flujo-credito-light-client-card.component.html',
    styleUrls: ['./flujo-credito-light-client-card.component.scss']
})
export class FlujoCreditoLightClientCardComponent {

    private canAccessFlujoCreditoLight = false;

    permissions: IFlujoLightTXPermissions[] = [];
    
    currentModel = '';
    currentIdTransaccion = '';
    generalReport!: IGeneralReport;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private flujoCreditoLightService: FlujoCreditoLightService,
        private alertService: AlertService,
        private _sessionService: SessionService
    ) { }

    ngOnInit(): void {
        this.canAccessFlujoCreditoLight = this.setCanAccessFlujoCreditoLight();

        if (!this.canAccessFlujoCreditoLight) {
            this.router.navigate(['/request-access']);
            return;
        }

        this.currentIdTransaccion = this.route.snapshot.paramMap.get('idTransaccion') || '';
        
        this.getPermissions();
        this.getGeneralReport(this.currentIdTransaccion);
    }

    setCanAccessFlujoCreditoLight () {
        const userAccess = this._sessionService.getUserAccess();

        const flujoCreditoLightPermission = [
            ESystemAccess.FLUJO_CREDITO_LIGHT,
            ESystemAccess.FLUJO_CREDITO_LIGHT_ADMIN,
            ESystemAccess.FLUJO_CREDITO_LIGHT_BUSCAR,
        ]

        return flujoCreditoLightPermission.some(permission => userAccess.includes(permission));
    }

    getPermissions(): void {
        this.flujoCreditoLightService.getPermissions().subscribe(
            permissions => {
                this.permissions = permissions;
            },
            error => {
                this.alertService.error(`Error al obtener permisos: ${error?.error?.message}`);
                goToTop();
            }
        );
    }

    validaClave(template: string): boolean {
        if (!this.currentModel) return false;
        if (!this.permissions || this.permissions.length <= 0) return false;

        const permissions = this.permissions.find(permission => permission.template === template);
        if (!permissions || !permissions?.models || permissions.models.length <= 0) return false;

        if (!permissions.models.includes(this.currentModel)) {
            this.flujoCreditoLightService.setModeloNotFound(true);
            this.router.navigate(['/flujo-credito-light']);
            return false;
        }

        return true;
    }

    getGeneralReport(idTransaccion: string): void {
        this.flujoCreditoLightService.getGeneralReport(idTransaccion).subscribe(
            report => {
                this.currentModel = report.datosBasicosSolicitud.modelo;
                this.generalReport = report;
            },
            error => {
                this.router.navigate(['/flujo-credito-light']);
                this.alertService.error(`Error al obtener reporte general: ${error?.error?.message}`);
                goToTop();
            }
        );
    }

}
